import { ParentChildHistory } from "@features/graph/state/parentChildHistory"
import { removeEdgeFromNode } from "@features/builder/helpers/remove-edge"
import { Edge, ReactFlowInstance } from "@xyflow/react"
import { AppNode, EdgeData } from "@features/builder/graph/types"
import {
  areLagsValid,
  hasEdgeCycle,
  hasTargetNodeLink,
  isSourceMissingUbound,
} from "@features/builder/helpers/edges"
import { enqueueSnackbar } from "notistack"

export const getItemColor = (id: string) => {
  if (id === ParentChildHistory.backward) return "rgba(0, 0, 255, 0.2)"
  return ""
}

export const removeChildEdge = (
  id: string,
  node: AppNode,
  nodes: AppNode[],
  reactFlowInstance: ReactFlowInstance<AppNode, Edge<EdgeData>>,
) => {
  const child = nodes.find((n) => n.id === id)
  if (!child) return
  const updatedNodes = removeEdgeFromNode(node, child, nodes)
  updatedNodes.forEach((updatedNode) => {
    reactFlowInstance.updateNode(updatedNode.id, updatedNode, { replace: true })
  })
}

export const removeParentEdge = (
  id: string,
  node: AppNode,
  nodes: AppNode[],
  reactFlowInstance: ReactFlowInstance<AppNode, Edge<EdgeData>>,
) => {
  const parent = nodes.find((n) => n.id === id)
  if (!parent) return
  const updatedNodes = removeEdgeFromNode(parent, node, nodes)
  updatedNodes.forEach((updatedNode) => {
    reactFlowInstance.updateNode(updatedNode.id, updatedNode, { replace: true })
  })
}

export const isEdgeConnectionValid = (
  parent: AppNode,
  child: AppNode,
  nodes: AppNode[],
  edges: Edge[],
  displayError = true,
) => {
  if (hasEdgeCycle({ target: child, source: parent, nodes, edges })) {
    if (displayError) enqueueSnackbar("This connection creates a cycle", { variant: "error" })
    return false
  }
  if (hasTargetNodeLink(child)) {
    if (displayError) enqueueSnackbar("Target node cannot have link.", { variant: "error" })
    return false
  }
  if (!areLagsValid({ source: parent, target: child })) {
    if (displayError) enqueueSnackbar("Child lag is greater than parent lag", { variant: "error" })
    return false
  }
  if (isSourceMissingUbound({ source: parent, target: child })) {
    if (displayError) enqueueSnackbar("Parent node has no ubound set", { variant: "error" })
    return false
  }
  return true
}
